import React, { useEffect, useState } from 'react';
import Modal from 'react-native-modal';
import { useWindowDimensions,  TextInput, KeyboardAvoidingView } from 'react-native';
import { Text, View } from '@constants/Themed';
import styles from '@stylesheet';
import Button from '@components/UI/Button/Button';
import LottieView from '@utils/lottieAnimation';
import useGlobalUser from '@hooks/getGlobalUser';
import { BlurView } from "@react-native-community/blur";
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import parseByDelimiter from '@utils/parseByDelimiter';

interface DeleteConfirmTypes {
  visibleState?: boolean;
  setState: Function;
  title?: string;
  refreshFunction?: Function;
  deleteFunction?: Function;
  itemId?: string,
  itemS?: any
}

const DeleteConfirmModal = ({
  deleteFunction,
  refreshFunction,
  visibleState,
  setState,
  title,
  itemId,
  itemS
}: DeleteConfirmTypes) => {
  
  const windowDimensions = useWindowDimensions();
  const [confirmState, setConfirmState] = useState("");
  const globalUser = useGlobalUser();
  const item = useSelector((state: DefaultRootState) => state.modals.dataModals.activeItem);
const theme = themeSelector();

  const handleDeleteFunction = async () => {
    if (deleteFunction) {
      console.log(globalUser, item._id)
      const res = await deleteFunction(itemId ? itemId : globalUser, (itemS ? itemS._id : item._id));
      if (res.status === 204) {
        setState(false);
      }
    }
  };

  return (
    <Modal
      isVisible={visibleState}
      animationIn={'zoomInDown'}
      animationOut={'zoomOutUp'}
      hasBackdrop={true}
      coverScreen={true}
      backdropColor="black"
      backdropOpacity={0.4}
      deviceHeight={windowDimensions.height}
      deviceWidth={windowDimensions.width}
      onBackdropPress={() => setState(false)}
      onModalHide={() => {
        setConfirmState("");
        if (refreshFunction) {
          refreshFunction();
        }
      }}
      style={{ alignContent: 'center', alignItems: 'center', alignSelf: 'center' }}
    >
      <BlurView
        style={styles.blurViewStyle}
        blurType={theme? "light": 'dark'}
        blurAmount={10}
        reducedTransparencyFallbackColor="white"
        pointerEvents='none'
      />
      <View style={[styles.modalContainerAuth, { backgroundColor: theme ? "white" :"#333333", alignItems: 'stretch', alignContent: 'space-around', minWidth: 400, minHeight: '85%', gap: 30, paddingHorizontal: 30 }]}>
        <KeyboardAvoidingView behavior='padding' keyboardVerticalOffset={180} style={{ flex: 1, paddingVertical: '10%' }}>
          <LottieView resizeMode='contain' source={require('@assets/animations/animation_lk4gcmkh.json')} autoPlay style={{ flex: 1, width: 200, maxHeight: 200, alignSelf: 'center' }} loop={false} />
          <View style={{ flex: 3, alignSelf: 'center', alignContent: 'space-around', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
            <Text style={{ textAlign: 'center' }}>Are you sure you want to delete <Text style={{ fontWeight: '600' }}>{parseByDelimiter(title)}</Text>? {'\n'} {'\n'} This action cannot be undone</Text>
            <Text style={{ fontStyle: 'italic', textAlign: "center" }}>Type <Text style={{ fontWeight: 'bold' }}>'DELETE'</Text> below to confirm</Text>
            <TextInput value={confirmState} onChangeText={setConfirmState} style={[styles.inputOutline, { color: theme ? 'black' : 'white', fontWeight: '600', borderRadius: 40, textAlign: 'center' }]} />
          </View>
          <View style={{ flexDirection: 'row', gap: 30, flex: 1, maxHeight: 80 }}>
            <Button customStyle={{ flex: 1, maxWidth: 180 }} textColor='white' onPress={() => setState(false)} buttonText={'Cancel'} />
            <Button customStyle={{ flex: 1, maxWidth: 180 }} defaultColor='red' textColor='white' disabled={confirmState != 'DELETE'} onPress={handleDeleteFunction} buttonText={'DELETE'} />
          </View>
        </KeyboardAvoidingView>
      </View>
    </Modal>
  )
}

export default DeleteConfirmModal;
